export default "__VITE_ASSET__DYX2UUAR__"